import { render, staticRenderFns } from "./DocumentosInscripcionesLayout.vue?vue&type=template&id=2dbf03b5"
import script from "./DocumentosInscripcionesLayout.vue?vue&type=script&lang=js"
export * from "./DocumentosInscripcionesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports